module.exports = __webpack_public_path__ + "static/media/hund.e30b2d44.mp3";